
import { defineComponent } from 'vue'
import { mapGetters, useStore } from 'vuex'
import { useEnvStore } from '@remote/store/env'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import SettingItem from '@remote/components/SettingItem.vue'
import SwitchBox from '@remote/components/switchbox/SwitchBox.vue'
import { useHeziVersionStore } from '@remote/store/version'
import { useHeziSettingsStore } from '@remote/store/settings'
import { checkNetworkState } from '@remote/store/utils'
import lang from './lang'
// import { delay } from '@remote/utils/base'
import { toast } from '@remote/utils'

export default defineComponent({
  components: { SettingItem, SwitchBox },
  setup: () => {
    document.title = lang.SettingsPage.title
    const envStore = useEnvStore()
    const store = useStore()
    const hzVersionStore = useHeziVersionStore()
    const hzSettingStore = useHeziSettingsStore()
    return { store, envStore, hzVersionStore, hzSettingStore }
  },
  data () {
    return {
      title: lang.SettingsPage.title,
      isAndroid,
      isIOS,
      lockState: {
        upgrade: false,
      },
    }
  },
  computed: {
    ...mapGetters(['isFullScreen']),
    hasNewVersion () {
      return this.hzVersionStore.state.hasNewVersion
    },
    isAutoUpgrade () {
      return this.hzSettingStore.state.isAutoUpgrade
    },
    $t () {
      return lang.SettingsPage
    },
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    gotoServiceListPage () {
      this.$router.push({
        name: 'services-detail',
        query: this.$route.query,
        // hash: '#me',
      })
    },
    async onAutoUpgradeToggle (isCheck: boolean) {
      console.log('[自动升级服务设置]:', isCheck)
      if (this.lockState.upgrade) return
      if (checkNetworkState(false)) return

      this.lockState.upgrade = true
      try {
        await this.hzSettingStore.toggleAutograde(isCheck)
      } catch (err) {
        console.error(err)
        toast('设置失败')
      } finally {
        this.lockState.upgrade = false
      }
    },
  },
})
